// Étape suivante permise sur un dossier « à soi » (même règle que le serveur).
export const NEXT_OWN_STATUS = {
  assigned: { value: 'in_progress', label: 'Commencer' },
  in_progress: { value: 'completed', label: 'Marquer terminé' },
};

export const nextOwnStatus = (status) => NEXT_OWN_STATUS[status] || null;
